import { Component,  Input,  OnInit, ViewChild } from '@angular/core';
import { AuthService } from '@shared/auth/auth.service';
import { SharedService } from '@shared/services/shared.service';


@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})

export class AdminComponent implements OnInit {

  isDev: boolean = false;

  constructor(
    private authService: AuthService,
    public sharedService: SharedService
  ) { }


  
  ngOnInit(): void {
    this.isDev = this.authService.userHasAtLeastOneRole(['Dev']);
  }

  gotoPage(page: string) {
    this.sharedService.doRedirect('admin/' + page);
  }

}
